var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('a',{attrs:{"href":_vm.href,"target":"_blank","rel":"noopener noreferrer"}},[_vm._t("default")],2),_c('sup',[_c('v-icon',{attrs:{"x-small":""}},[_vm._v(" open_in_new ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }